export const YES_NO_TYPES = [
  {
    value: "SI",
  },
  {
    value: "NO",
  },
]
